import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable({
  providedIn: 'root'
})
export class AccountService extends RestfulService<Models.Account> {

  constructor(public restService: RestService) {
    super(Models.Account);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('accounts');
  }
}
